import { Box, Paper, Typography } from "@mui/material";
import { GroupedButton } from "../../common/components/ButtonGroup";
import { useInspectionLog } from "../../common/hooks/useInspectionLog";
import { DataTable } from "../../common/components/DataTable";
import { ToolDetailsMockComponent } from "./components/ToolDetailsMockComponent";
import { useDefectLogs } from "../../common/hooks/useDefectLog";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useState } from "react";

interface InspectionLog {
  chip_type: string;
  grade: string;
  inspection_runtime_ms: number;
  rotation: number;
  serial_no: string;
  x_coordinate: number;
  y_coordinate: number;
  _time: string;
}

export const TIME_RANGE = [
  { label: "Last 1 hour", value: "-1h" },
  { label: "Last 6 hours", value: "-6h" },
  { label: "Last 24 hours", value: "-24h" },
  { label: "Last 7 days", value: "-7d" },
  { label: "Custom", value: "custom" },
];

const DATA_SET = [
  { label: "Mock Data", value: "mock" },
  { label: "Live Data", value: "live" },
];

export const Inspection = () => {
  const [selectedTab, setSelectedTab] = useState("1");

  const { inspectionLogs, loading } = useInspectionLog(
    "2025-06-01T23:59:59Z",
    "now()"
  );

  const { defectLogs, loading: defectLoading } = useDefectLogs(
    "2025-06-01T23:59:59Z",
    "now()"
  );

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  const columnOrder = inspectionLogs?.map((col: InspectionLog) => {
    const logId = `Log${col?.serial_no}`;
    const time = col?._time;
    const inspectionRuntime = col?.inspection_runtime_ms;
    const xCoordinate = col?.x_coordinate;
    const yCoordinate = col?.y_coordinate;
    const rotation = col?.rotation;
    const grade = col?.grade;
    const chipType = col?.chip_type;
    return {
      logId,
      time,
      inspectionRuntime,
      xCoordinate,
      yCoordinate,
      rotation,
      grade,
      chipType,
    };
  });

  const tabOptions = [
    {
      label: "Inspection Log",
      value: "1",
      isAccordion: true,
      data: columnOrder,
      loading,
    },
    {
      label: "Defect Log",
      value: "2",
      isAccordion: false,
      data: defectLogs as [],
      loading: defectLoading,
    },
  ];

  return (
    <>
      <Box
        sx={{
          p: 4,
          width: "100%",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 3,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Inspection
          </Typography>
          <GroupedButton variant="outlined" buttons={DATA_SET} />
        </Box>

        <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center" }}>
          <GroupedButton variant="outlined" buttons={TIME_RANGE} />
        </Box>

        <ToolDetailsMockComponent />

        <Paper sx={{ p: 3, borderRadius: 2 }}>
          <Tabs onChange={handleChange}>
            {tabOptions.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                sx={{
                  color:
                    selectedTab === tab.value ? "primary.main" : "text.primary",
                  fontSize: "15px",
                  p: 1,
                }}
              />
            ))}
          </Tabs>

          {tabOptions.map(
            (tab) =>
              selectedTab === tab.value && (
                <DataTable
                  key={tab.value}
                  data={tab.data}
                  loading={tab.loading}
                  isAccordion={tab.isAccordion}
                />
              )
          )}
        </Paper>
      </Box>
    </>
  );
};
